<template>
    <v-container>
        <v-row>
            <v-col cols="12" sm="6">
                <h1 class="subtitle-1 grey--text mb-4">Raport încasări - plăți</h1>
            </v-col>
            <v-col cols="12" sm="6" class="text-right">
                <v-btn color="success" 
                    @click="getCashInCashOutAsXls"
                    :loading="downloadBtnLoading"
                >Decarcă fisier Excel <v-icon right dark>mdi-microsoft-excel</v-icon></v-btn> 
            </v-col>
        </v-row>
        <v-card class="pa-4">
        <v-row >
            <v-col class="d-flex" cols="12" sm="3">
                <date-range-picker
                    ref="picker"
                    v-model="dateRange"
                    
                    @update="updateValues"
                    :locale-data="localeData"
                >
                    <template #input="picker" style="display: block;">
                        <v-text-field 
                            label="Perioada"
                            :value="selectedPeriod"
                            :dummy="picker"
                            hide-details
                            prepend-icon="mdi-calendar"
                            dense
                        >
                        </v-text-field>
                    </template>
                </date-range-picker>
            </v-col>
            <v-col class="d-flex" cols="12" sm="3">
                <v-select
                    v-model="judetSelectat"
                    :items="judete"
                    label="Județ"
                    item-text="name"
                    item-value="id"
                    clearable
                    v-on:change="updateValues"
                    hide-details
                    dense
                ></v-select>
            </v-col>
            <v-col class="d-flex" cols="12" sm="3">
                <v-select
                    v-model="produseSelectateStore"
                    :items="produse"
                    item-text="gameName"
                    item-value="gameId"
                    small-chips
                    deletable-chips
                    label="Produse"
                    multiple
                    clearable
                    v-on:change="updateValues"
                    hide-details
                    dense
                >
                </v-select>
            </v-col>
            <v-col class="d-flex" cols="12" sm="3">
                <v-select
                    v-model="raportTypeSelectat"
                    :items="raportType"
                    label="Tip raport"
                    item-text="name"
                    item-value="id"
                    clearable
                    v-on:change="updateValues"
                    hide-details
                    dense
                ></v-select>
            </v-col>
        </v-row>
        <v-row class="pt-0">
            <v-col class="d-flex" cols="12" sm="2">
               <v-checkbox
                v-model="ownShop"
                label="Agenții proprii"
                v-on:change="updateValues"
                dense
                hide-details
                ></v-checkbox>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
               <v-checkbox
                v-model="onlyWithStakeAndPayments"
                label="Doar cu încasări + plăți"
                v-on:change="updateValues"
                dense
                hide-details
                ></v-checkbox>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
                <v-select
                    v-model="managerGroupSelected"
                    :items="managerGroups"
                    label="Grup"
                    item-text="groupName"
                    item-value="groupId"
                    clearable
                    v-on:change="updateValues"
                    hide-details
                ></v-select>
            </v-col>
            <v-col class="d-flex" cols="12" sm="3">
                <v-select
                    v-model="terminaleSelected"
                    :items="terminale"
                    label="Terminale"
                    item-text="name"
                    item-value="id"
                    clearable
                    v-on:change="updateValues"
                    hide-details
                ></v-select>
            </v-col>
            <v-col class="d-flex" cols="12" sm="3">
                <v-btn color="primary" 
                    @click="updateData"
                    
                ><v-icon left dark>mdi-reload</v-icon> Reîncarcă</v-btn> 
            </v-col>
        </v-row>
        </v-card>
        <v-row align="center">
            <v-col>
                <v-card>
                    <v-card-title>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                    ></v-text-field>
                    </v-card-title>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        class="elevation-1"
                        :loading="tableLoading"
                        :text-loading="tableLoadingText"
                        :search="search"
                        :sort-by="['total-incasari']"
                        :sort-desc="[true]"
                        :footer-props="{
                                'items-per-page-options': [10, 20, 30, 40, 50]
                            }"
                        :items-per-page="20"
                    ></v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    
    components: { DateRangePicker },

    data: function() {
        return {
            search: '',
            dateRange: {
                startDate: this.$moment().subtract(1, 'days').toISOString().substr(0, 10), 
                endDate: this.$moment().subtract(1, 'days').toISOString().substr(0, 10)
            },
            localeData: {
                format: 'yyyy-mm-dd',
            },
            tableLoading: true,
            tableLoadingText: "Se încarcă... Te rog așteaptă",
            produseSelectateStore: [],
            judetSelectat: null,
            raportType: [
                {id: 0, name: 'Complet', nameEng: 'Complete'},
                {id: 1, name: 'Doar Miza', nameEng: 'OnlyStake'},
                {id: 2, name: 'Doar Taxe', nameEng: 'OnlyTaxes'},
                {id: 3, name: 'Doar Operatii casa', nameEng: 'CashInCashOut'},
                {id: 4, name: 'Doar Totaluri', nameEng: 'OnlyTotal'},
            ],
            raportTypeSelectat: 4,
            terminale: [
                {id: 0, name: 'Inclusiv terminale'},
                {id: 1, name: 'Fară terminale'},
                {id: 2, name: 'Doar terminale'}
            ],
            terminaleSelected: 1,
            ownShop: false,
            onlyWithStakeAndPayments: true,
            managerGroupSelected: null,
            downloadBtnLoading: false,
        }
    },
    computed: {
        headers(){
            return this.$store.getters['raportIncasariPlati/getHeaders'];
        },
        items(){
            return this.$store.getters['raportIncasariPlati/getItems'];
        },
        judete(){
            return this.$store.getters['getJudete'];
        },
        produse(){
            console.log('produse ' + this.$store.getters['getProduse'] );
            return this.$store.getters['getProduse'];
        },
        managerGroups(){
            return this.$store.getters['getManagerGroups'];
        },
        selectedPeriod(){
            return this.$moment(this.dateRange.startDate).format('YYYY-MM-DD') + ' - ' + this.$moment(this.dateRange.endDate).format('YYYY-MM-DD');
        },
        produseSelectate(){
            if(this.produseSelectateStore.length == 0){
                let response = [];
                this.produse.forEach(element => {
                    response.push(element.gameId);
                });
                return response;
            }else{
                return this.produseSelectateStore;
            }
        },
        rangeHelper(){
            let today = new Date()
            today.setHours(0, 0, 0, 0)

            let yesterday = new Date()
            yesterday.setDate(today.getDate() - 1)
            yesterday.setHours(0, 0, 0, 0);

            let thisMonthStart = this.$moment().startOf('month');
            let thisMonthEnd = this.$moment().endOf('month');

            return {
                'Azi': [today, today],
                'Ieri': [yesterday, yesterday],
                'Luna curentă': [thisMonthStart, thisMonthEnd],
                'Anul curent': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
                'Luna trecută': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
            };

        }
    },
    created() {
        this.updateData();
    },
    methods: {
        updateData(){
            
            this.tableLoading = true;
            this.$store.dispatch('raportIncasariPlati/getCashInCashOut', {
                dateFrom: this.$moment(this.dateRange.startDate).format('YYYY-MM-DD'),
                dateTo: this.$moment(this.dateRange.endDate).format('YYYY-MM-DD'),
                games: this.produseSelectate,
                idJudet: this.judetSelectat,
                reportType: this.raportTypeSelectat,
                ownShop: this.ownShop,
                onlyWithStakeAndPayments: this.onlyWithStakeAndPayments,
                type: this.terminaleSelected

            }).then(()=>{
                this.tableLoading = false;
            });
        },
        updateValues(){
            console.log(this.produseSelectate);
            this.updateData();
        },
        getCashInCashOutAsXls(){
            this.downloadBtnLoading = true;
            this.$store.dispatch('raportIncasariPlati/getCashInCashOutAsXls',{
                dateFrom: this.$moment(this.dateRange.startDate).format('YYYY-MM-DD'),
                dateTo: this.$moment(this.dateRange.endDate).format('YYYY-MM-DD'),
                games: this.produseSelectate,
                idJudet: this.judetSelectat,
                reportType: this.raportTypeSelectat,
                ownShop: this.ownShop,
                onlyWithStakeAndPayments: this.onlyWithStakeAndPayments,
                type: this.terminaleSelected
            }).then(()=>{
                this.downloadBtnLoading = false;
            })
        }
    },
}
</script>

<style>
.v-data-table {
    max-width: 100%
}
.reportrange-text {
    border: none !important; 
    padding-left: 0 !important;
}
.vue-daterange-picker {
    display: block !important;
    width: 100% !important;
}
</style>